<template>
  <div class="case-design-wrap">
    <xl-scrollbar ref="scrollbarRef">
    <div class="content">
        <div class="up-wrap">
            <div class="aside">
                <div class="head-tlt">{{$t('design.case.chooseTeethJaws') || '选择牙颌'}}</div>
                <div class="design-tooth">
                    <xl-scrollbar>
                        <tooth 
                            :type="type" 
                            :toothType="toothType" 
                            :singleDisabledTeeth="singleDisabledTeeth"
                            :selectSingleTip="selectSingleTip"
                            ref="toothRef"
                            @change="onToothChange"
                        ></tooth>
                    </xl-scrollbar>
                </div>
            </div>
            <div class="design-wrap">
                <div class="head-tlt">{{$t('design.preference.designPreference') || '设计偏好'}}</div>
                <div class="design-content" v-if="tooths.length">
                    <!-- 选择的牙号 上颌/下颌， 全颌 -->
                    <div class="design-top">
                        <div class="tooths-wrap">
                            <xl-scrollbar ref="rowscrollbarRef">
                            <div class="tooths">
                                <span v-for="item in tooths" :key="item" 
                                    class="item" 
                                    @click="onClickDesignItem(item)"
                                    :class="activeDesignItem === item ? 'item-acitve' : ''"
                                >{{ transName(item) }}</span>
                            </div>
                            </xl-scrollbar>
                        </div>
                        <xl-checkbox 
                            v-show="props.info.productConfig !== 'prod_partial_removable_denture'"
                            v-model="ckboxBoolean" @change="onSavePreference">
                            {{$t('design.case.saveToPreference') || '保存至设计偏好'}}
                        </xl-checkbox>
                    </div>
                    <preference-product 
                        class="case-design-preference"
                        v-for="item in tooths" 
                        v-show="activeDesignItem === item"
                        :formConfigObj="preferenceConfig.preferences || []"
                        :extraData="preferenceConfig.extra || ''"
                        :selectProduct="selectProduct"
                        :showScanningRod="showScanningRod"
                        :showDashedBorder="showDashedBorder"
                        :currentType="currentType"
                        :key="item" 
                        :isShow="activeDesignItem === item && props.activeStep === 1"
                        :ref="
                            (el) => {
                                preferenceRefs[item] = el;
                            }
                        "
                    ></preference-product>
                </div>
                <div class="design-content" v-else>
                    <noData :text="$t('design.case.chooseTooth')"></noData>
                </div>
            </div>
        </div>
        <div v-if="!props.info?.activeCommodity?.aiProduct" class="down-wrap">
            <div class="desc-wrap">
                <div class="head-tlt">{{$t('design.orderDetail.designRequirement') || '设计需求'}}</div>
                <div class="desc">
                    <xl-input ref="descRef" type="textarea" :autosize="{ minRows: 8 }" v-model="descValue" :placeholder="$t('design.case.enterOtherRequirements') || '请输入其他需求'" maxlength="2000"></xl-input>
                </div>
            </div>
        </div>
    </div>
    </xl-scrollbar>
    <div class="footer">
        <xl-button type="primary" @click="onNext">{{$t('design.goNext') || '下一步'}}</xl-button>
        <xl-button class="pre-btn" @click="onPre">{{$t('design.goBack') || '上一步'}}</xl-button>
        <xl-button v-if="!props.info?.activeCommodity?.aiProduct" @click="onOther"><i class="iconfont icon-tianjia"></i>{{ $t('design.orderDetail.otherRequirement') || '其他需求'}}</xl-button>
    </div>
  </div>
</template>

<script setup>
// 选择设计需求
import { ref, defineEmits, defineProps, computed, watch, defineExpose, nextTick } from 'vue';
import { XlButton, XlInput, XlUpload2, XlMessage, XlScrollbar, XlCheckbox } from '@shining3d/ui-components';
import tooth from './components/tooth.vue';
import { useLang } from "@shining3d/common-module/utils/lang.js";
import PreferenceProduct from '../preference/components/preferenceProduct.vue';
import noData from '../../components/no-data.vue';
import { transToothName } from '../../utils/common';
import { preferProductMap } from '../../common/enum.js'; 
const { $t } = useLang("@shining3d/xl-design-order");

const emits = defineEmits(['pre', 'next']);
const props = defineProps({
    info: {
        type: Object,
        default: {}
    },
    activeStep: Number
});

const type = ref('perPiece'); // 牙号类型 perJaw
const toothType = ref('repair'); // perPiece 下选择牙的类型，种植需要是 'plant', 其余是 'repair'
const descValue = ref( '' );
const singleDisabledTeeth = ref(false); // 牙位图是否只能选择单颗牙
const selectSingleTip = ref('') // 牙位图选择单颗牙文案

const currentType = ref(''); // 展示设计偏号的图片类型
// 扫描杆是否展示
const showScanningRod = ref(false);
const preferenceConfig = ref({});
const selectProduct = ref('');
const showDashedBorder = ref(false);

watch(() => props.info, (newValue, oldValue) => {
    if ( newValue.activeCommodity?.productID !==  oldValue.activeCommodity?.productID ) {
        // 更换了选中的商品后，置空一些信息
        type.value = newValue.activeCommodity?.toothPositionSelector; // 牙号选择的单位
        singleDisabledTeeth.value = Boolean(newValue.activeCommodity?.aiProduct);
        selectSingleTip.value = newValue.activeCommodity?.aiProduct ? newValue.activeCommodity?.tips : '';
        // toothType.value = newValue.productType === 'cat_implant' ? 'plant' : 'repair';
        if ( type.value === 'selectorPerPiece') {
            // 普通颗
            type.value = 'perPiece';
            toothType.value = 'repair';
        } else if ( type.value === 'selectorPerAbutmentPiece') {
            //  基台颗
            type.value = 'perPiece';
            toothType.value = 'plant';
        } else if ( type.value === 'selectorPerHole' ) {
            type.value = 'perHole';
            toothType.value = 'hole';
        } else if ( type.value === 'selectorPerCase') {
            type.value = 'perCase';
            tooths.value = ['perCase'];
            activeDesignItem.value = 'perCase';
        } else if ( type.value === 'selectorPerJaw' ) {
            type.value = 'perJaw';
        }
        currentType.value = preferProductMap[newValue.productConfig]?.imageType;
        showScanningRod.value = preferProductMap[newValue.productConfig]?.showScanningRod || false;
        showDashedBorder.value = preferProductMap[newValue.productConfig]?.showDashedBorder || false;
        selectProduct.value = newValue.productConfig;
        preferenceConfig.value = newValue.preferenceConfig;
    }
});

const toothRef = ref(null);
const ckboxValue = ref('');

// 选中的active 牙tab
const activeDesignItem = ref('');
const onClickDesignItem = ( item ) => {
    activeDesignItem.value = item;
};

const ckboxBoolean = computed(() => (ckboxValue.value === activeDesignItem.value) && Boolean(activeDesignItem.value));

const rowscrollbarRef = ref();
const tooths = ref([]); // 选中的牙号信息
const signType = ref('FDI')
const onToothChange = async (data) => {
    tooths.value = data.tooths;
    signType.value = data?.signType || 'FDI';
    if ( data?.activeTooth ) {
        activeDesignItem.value = data?.activeTooth;
    }
    
    // 没有 activeDesignItem 或 activeDesignItem不在tooths列表里 时，默认选中第一个牙tab。
    if ( !activeDesignItem.value || !tooths.value.includes(activeDesignItem.value)) {
        activeDesignItem.value = tooths.value.length ? tooths.value[0] : ''
    }
    // 清楚了所有选中牙号，保存的设计偏号也要置空
    if ( !tooths.value.length ) {
        ckboxValue.value = '';
    }
    await nextTick();
    rowscrollbarRef.value?.update()
};

const transName = ( toothName ) => {
    let showName = transToothName( toothName, signType.value );
    if ( type.value === 'perPiece' || type.value === 'perHole' ) {
        // 按颗的牙，展示 xxx号牙 `${showName}号牙`;
        showName = $t('design.case.perferenceTooth', {
           tooth: showName
        });
    }
    return showName;
};

const onSavePreference = ( val ) => {
    if ( val ) {
        // 选择保存了设计偏好
        ckboxValue.value = activeDesignItem.value;
        const name = transName(ckboxValue.value);
        XlMessage({
            type: 'success',
            // `已将${name}保存为设计偏好`
            message: $t('design.case.saveToothPerference.tip', {
                tooth: name
            })
        });
    } else {
        ckboxValue.value = '';
    }
};

const validate = () => {
    const toothResult = toothRef.value.validate();
    if ( !toothResult.valid ) {
        return {
            valid: false,
            message: toothResult.message
        };
    }
    // if ( !descValue.value ) {
    //     return {
    //         valid: false,
    //         message: $t('design.need.designcontent') || '请输入设计需求'
    //     }
    // }
    return {
        valid: true
    };
};

const preferenceRefs = ref({});
const getValue = () => {
    const toothValue = toothRef.value.getValue();
    
    // 设计偏好的保存值
    const preferenceValue = {};
    Object.keys(preferenceRefs.value).forEach(item => {
        if (preferenceRefs.value[item]) {
            // 牙号：设计偏好表单所有值
            preferenceValue[item] = preferenceRefs.value[item].getValue();
        }
    });

    return {
        ...toothValue,
        designContent: descValue.value,
        preferenceValue, // 设计偏好值
        ckboxValue: ckboxValue.value,
        preferenceConfig: preferenceConfig.value
    }
};

const onNext = () => {
    const result = validate();
    if ( !result.valid ) {
        XlMessage({
            type: 'warning',
            message: result.message
        });
        return;
    }
    
    const data = getValue();
    emits('next', {
        data,
        index: [0, 1, 2] 
    });
};

const descRef = ref();
const scrollbarRef = ref();
const onOther = () => {
    const ele = scrollbarRef.value?.wrap$;
    const scrollHeight = ele.scrollHeight;
    scrollbarRef.value.setScrollTop( scrollHeight );
    descRef.value?.xlElementRef.focus();
};

const onPre = () => {
    emits('pre');
};

const resetData = () => {
    descValue.value = '';
    toothRef.value.resetData();
    toothType.value = 'repair';
    ckboxValue.value = '';
    tooths.value = []; // 选中的牙号也置空
    preferenceRefs.value = {};
};

defineExpose({ resetData, validate, getValue });
</script>

<style lang="scss" scoped>
$case-border-color: #E0E4EA;
.case-design-wrap {
    display: flex;
    flex: 1;
    flex-direction: column;
    height: 100%;
    padding-top: 24px;
    box-sizing: border-box;
    .content {
        flex: 1;
        box-sizing: border-box;
        margin: 0px 0px 19px 16px;
        padding-right: 16px;
        overflow-y: auto;
        .head-tlt {
            background-color: #F2F3F7;
            text-align: center;
            height: 48px;
            line-height: 48px;
            font-size: 14px;
            font-weight: 700;
            color: #42526E;
            border-top-left-radius: 10px;
            border-top-right-radius: 10px;
        }
        .up-wrap {
            display: flex;
            height: 624px;
            overflow: hidden;
        }
        .aside {
            width: 258px;
            min-width: 258px;
            margin-right: 16px;
            background: #FAFBFD;
            border-radius: 10px;
            height: 100%;
            display: flex;
            flex-direction: column;
            .design-tooth {
                flex: 1;
                overflow-y: auto;
                height: 100%;
                box-sizing: border-box;
                padding-top: 24px;
            }
        }
        .design-wrap {
            height: 100%;
            flex: 1;
            background: #FAFBFD;
            border-radius: 10px;
            display: flex;
            flex-direction: column;
            overflow: hidden;

            .design-content {
                box-sizing: border-box;
                flex: 1;
                padding-left: 16px;
                padding-top: 12px; 
                display: flex;
                flex-direction: column;
                overflow: hidden;
            }
            .design-top {
                display: flex;
                align-items: center;
                padding-right: 16px;

                :deep(.xl-checkbox) {
                    padding-bottom: 12px;
                }
            }
            .tooths-wrap {
                flex: 1;
                width: 100%;
                padding-right: 16px;
                overflow: hidden;
            }
            .tooths {
                padding-bottom: 12px;
                display: flex;
                margin-right: 16px;
                // overflow-x: auto;
                .item {
                    flex-shrink: 0;
                    // width: 76px;
                    min-width: 76px;
                    height: 36px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    box-sizing: border-box;
                    border: 2px solid #E0E4EA;
                    font-size: 14px;
                    font-weight: 500;
                    font-family: $font-family65;
                    border-radius: 6px;
                    margin-right: 12px;
                    cursor: pointer;
                    padding: 0 16px;
                    white-space:nowrap;
                    &:last-child {
                        margin-right: 0px;
                    }
                }
                .item-acitve {
                    border-color: #5587FF;
                    color: #5587FF;
                }
            }

            :deep(.preference-product-box) {
                flex: 1;
                width: 100%;
                overflow: hidden;
                .form-left {
                    background: transparent;
                    padding-top: 0px;
                    margin-right: 0px;
                    width: 370px;
                    height: 100%;
                    .top-form {
                        padding-left: 0px;
                    }
                    .el-form {
                        .el-form-item {
                            margin-bottom: 8px !important;
                        }
                    }
                    .footer {
                        display: none;
                    }
                }
                .right {
                    background: transparent;
                }
            }
        }
        .down-wrap {
            margin-top: 24px;
            min-height: 231px;
            .desc-wrap {
                background: #FAFBFD;
                border-radius: 10px;
                .desc {
                    box-sizing: border-box;
                    padding: 16px;

                    :deep(.el-textarea) {
                        border: none !important;
                        background-color: none !important;
                        min-height: 183px;

                        .el-textarea__inner {
                            color: #42526E;
                        }
                    }
                    :deep(.el-textarea__inner) {
                        padding: 0px !important;
                        outline: none !important;
                        resize: none !important;
                        background: transparent !important;
                        border: none !important;
                        box-shadow: none !important;
                        &:focus {
                            box-shadow: none !important;
                        }
                        &:hover {
                            background: transparent !important;
                        }
                    
                    }
                    
                }
            }
        }
    }

    .footer {
        margin-right: 16px;
        box-sizing: border-box;
        height: 68px;
        display: flex;
        border-top: 1px solid $case-border-color;
        align-items: center;
        flex-direction: row-reverse;

        .pre-btn {
            margin-right: 16px;
            margin-left: 16px;
        }
        .icon-tianjia {
            padding-right: 4px;
        }
    }
}
</style>